import { PERIOD, UNIT } from '../constants';

export const TIMELINE = {
  [PERIOD.DAY]: {
    scales: {
      xAxes: [
        {
          type: 'time',
          time: {
            unit: 'hour',
            unitStepSize: 1,
            displayFormats: { hour: 'h A' },
          },
        },
      ],
    },
  },
  [PERIOD.WEEK]: {
    scales: {
      xAxes: [
        {
          type: 'timecenter',
          time: {
            unit: 'day',
            unitStepSize: 1,
            displayFormats: { day: 'ddd' },
          },
        },
      ],
    },
  },
  [PERIOD.MONTH]: {
    scales: {
      xAxes: [
        {
          type: 'timecenter',
          time: {
            unit: 'day',
            unitStepSize: 1,
            displayFormats: { day: 'MMM D' },
          },
        },
      ],
    },
  },
  [PERIOD.QUARTER]: {
    scales: {
      xAxes: [
        {
          type: 'timecenter',
          time: {
            unit: 'month',
            unitStepSize: 1,
            displayFormats: { month: 'MMM' },
          },
        },
      ],
    },
  },
  [PERIOD.YEAR]: {
    scales: {
      xAxes: [
        {
          type: 'timecenter',
          time: {
            unit: 'month',
            unitStepSize: 1,
            displayFormats: { month: 'MMM' },
          },
        },
      ],
    },
  },
  [PERIOD.HIGH]: {
    scales: {
      xAxes: [
        {
          type: 'time',
          time: {
            unit: UNIT[PERIOD.HIGH],
            unitStepSize: 1,
            displayFormats: { year: 'YYYY' },
          },
        },
      ],
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/common/Charts/options/timeline.js